import { memo, useMemo } from "react";
import Typography from "components/Typography";
import { useTranslation } from "react-i18next";
import Dialog from "components/DialogV2";
import DialogHeader from "components/DialogV2/DialogHeader";
import DialogTitle from "components/DialogV2/DialogTitle";
import DialogClose from "components/DialogV2/DialogClose";
import DialogContent from "components/DialogV2/DialogContent";
import DialogActions from "components/DialogV2/DialogActions";
import Button from "components/Button";

interface DeleteLeaderboardDialogProps {
  name?: string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

function DeleteLeaderboardDialog(props: DeleteLeaderboardDialogProps) {
  const { open, onClose, onConfirm, name } = props;
  const { t } = useTranslation();

  const dialogTitle = useMemo(() => {
    if (!name) return t("leaderboard.delete_dialog_title_unnamed");
    return t("global.are_you_sure_to_delete_name", { name });
  }, [name, t]);

  return (
    <Dialog open={open} onClose={onClose} width={450}>
      <DialogHeader>
        <DialogTitle>{t("leaderboard.delete_dialog_header")}</DialogTitle>
        <DialogClose />
      </DialogHeader>
      <DialogContent sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        <Typography textAlign="center" fontWeight="fontWeightMedium">
          {dialogTitle}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ flexDirection: "column", gap: 2, pt: 2 }}>
        <Button variant="danger" size="small" fullWidth onClick={onConfirm}>
          {t("leaderboard.delete_dialog_button_text")}
        </Button>
        <Button variant="tertiary" size="small" fullWidth onClick={onClose}>
          {t("global.cancel_button_text")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default memo(DeleteLeaderboardDialog);
